
  import { Component, Prop, Vue } from "vue-property-decorator";
  import { Contractor, Manager } from "@/generated/graphql";
  import Roles from "@/entities/Roles";
  import GroupConversationUser from "@/entities/GroupConversationUser";

  @Component
  export default class GroupConversationProvider extends Vue {
    @Prop({ type: String, required: true }) readonly currentUserRole!: Roles;
    @Prop({ type: Array, default: () => [] }) readonly contractors!: Contractor[];
    @Prop({ type: Array, default: () => [] }) readonly managers!: Manager[];

    get participantsExist(): boolean {
      return this.groupConversationUsers.length > 0;
    }

    get groupConversationUsers(): GroupConversationUser[] {
      const managers = this.groupManagers.map(manager => {
        return {
          ...manager,
          name: `${manager.name} (manager)`
        }
      })
      return [...this.groupContractors, ...managers];
    }

    get groupManagers(): GroupConversationUser[] {
      const adminRole = this.currentUserRole === Roles.ADMIN;
      const managerExists = this.managers.length > 0;

      if (!managerExists || !adminRole) {
        return [];
      }

      return this.managers.map(({ manager }: any) => {
        return {
          userId: manager.user.id,
          name: `${manager.user.given_name} ${manager.user.family_name}`,
          avatar: manager.user.avatar,
        };
      });
    }

    get groupContractors(): GroupConversationUser[] {
      if (!this.contractors.length) {
        return [];
      }
      return this.contractors.map(({ contractor }: any) => {
        return {
          userId: contractor.user.id,
          name: `${contractor.user.given_name} ${contractor.user.family_name}`,
          avatar: contractor.user.avatar,
        };
      });
    }

  }
